import React, { useEffect, useState } from "react";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { useForm,Controller } from "react-hook-form";
import Axios from "axios";
import Swal from 'sweetalert2';
import LoadingSpinner from "../helpers/loadingspinner";
import { GetJobRoles, AddQuestionsList, GetTestTypes } from "../apiconstants/constants";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import { Link, useNavigate } from "react-router-dom";
import WYSIWYGEditor from "../helpers/WYSIWYGEditor"
import { useCountry } from "../contexts/countrycodecontext.js";
import Select from "react-select";
const AddQuestions = () => {
    const { register, handleSubmit,control, formState: { errors, isSubmitting }, reset } = useForm();
    const navigate=useNavigate();
    const [isDisabled, setIsDisabled] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [jobRoles, setJobRoles] = useState([]);
    const [testTypes, setTestTypes] = useState([]);
     let Guid="";
     const guid = localStorage.getItem("guid");
     const employerGuid = localStorage.getItem("employerGuid")
     const email = localStorage.getItem("email")
     const roleID = localStorage.getItem("roleID")
     const token = localStorage.getItem("jwtToken");
       const { selectedCountry} = useCountry();
     const jobRoleOptions = jobRoles.map(role => ({
  value: role.jobRoleId,
  label: role.jobRole
}));
     if(roleID==3){
      Guid = employerGuid
     }
     else{
       Guid= guid
     }
    const fetchJobRoles = () => {
    const getApiUrl = `${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`;
        Axios.get(getApiUrl).then((response) => {
            setJobRoles(response.data);
        }).catch((error) => {
            console.error("Error fetching job roles", error);
        });
    };
const stripHTML = (html) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  return tempDiv.textContent || tempDiv.innerText || "";
};
    const fetchTestTypes = () => {
        const getTestTypesUrl = GetTestTypes.APIURL;
        Axios.get(getTestTypesUrl,{headers: { Authorization: `Bearer ${token}` } }).then((response) => {
            setTestTypes(response.data);
        }).catch((error) => {
            console.error("Error fetching test types", error);
            if (error?.response?.status === 401) {
                Swal.fire({
                    position: 'center',
                    icon: 'warning',
                    title: 'Session Timeout',
                    text: 'Your session has expired. Please login again.',
                    confirmButtonText: 'OK',
                }).then(() => {
                    localStorage.removeItem("jwtToken");
                    navigate("/Login");
                });
                return;
            }

            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Unable to load test types',
                text: 'Please try again in a moment.',
                confirmButtonText: 'OK',
            });
        });
    };

    const onSubmit = (data, e) => {
        e.preventDefault();
        setIsLoading(true);
        addData(data);
        reset();
    };

    const addData = async (data) => {
        setIsLoading(true);
        const apiAddUrl = AddQuestionsList.APIURL;
      const params = {
    question: stripHTML(data.question),
    answer: stripHTML(data.answer),
    jobRoleID: data.jobRoleID?.value || 0,
    testTypeID: Number(data.testTypeID),
    createdBy: email,
    userGuid: Guid,
    countryID: selectedCountry
  };
        console.log("result", params);
        Axios.post(apiAddUrl, params, {
            headers: {
                'Content-Type': 'application/json',
                 "Authorization": `Bearer ${token}`,
            }
        })
            .then((result) => {
                setIsLoading(false);
                if (result.data.message === "Questions  added successfully") {
                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Submitted Successfully',
                        showConfirmButton: false,
                        timer: 5000
                    });
                    // navigate("/Employer/Questions")
                } else {
                    Swal.fire({
                        position: 'center',
                        icon: 'error',
                        title: 'Not Submitted',
                        showConfirmButton: false,
                        timer: 7000
                    });
                }
            })
            .catch(() => {
                setIsLoading(false);
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Something went wrong, try again',
                    showConfirmButton: false,
                    timer: 7000
                });
            });
    };
   
    useEffect(() => {
        fetchJobRoles();
        fetchTestTypes();
    }, [selectedCountry]);

    return (
        <ConsultantLayout>
            <section>
                {
                    isLoading ? <center><LoadingSpinner /></center> :
                        <div className="container-fluid mt-4 pb-5">
                                      <div style={{ display: 'flex', alignItems: 'center' }}>
  <Link to="/Employer/Questions">
    <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px', marginTop: 8}} aria-hidden="true"></i>
  </Link>
  <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: 8 }}>Add Question</h2>
</div>
                            <hr />
                            <div class="card shadow-lg mt-5 p-5" style={{border:"none"}}>
                        
                        <div class="row mt-2">
                                <form onSubmit={handleSubmit(onSubmit)} id="loginform">
                                    <div className="row p-3">
                                        <div className="row mt-0 p-2">
                                            <div className="col-12">
                                               <OverlayTrigger
  placement="bottom"
  overlay={<Tooltip id="tooltip">Select Job Role</Tooltip>}
>
  <div className="mt-3">
    <Controller
      name="jobRoleID"
      control={control}
      rules={{ required: "Job Role Required" }}
      render={({ field }) => (
        <Select
          {...field}
          options={jobRoleOptions}
          placeholder="Select Job Role"
          classNamePrefix="react-select"
          styles={{
            control: (base, state) => ({
              ...base,
              height: 50,
              borderRadius: 15,
              fontSize: 12,
              borderColor: errors.jobRoleID ? "red" : base.borderColor,
            })
          }}
        />
      )}
    />
    {errors.jobRoleID && (
      <span className="text-danger">{errors.jobRoleID.message}</span>
    )}
  </div>
</OverlayTrigger>

                                                <div className="invalid-feedback"> {errors.jobRoleID?.message}</div>
                                            </div>
                                        </div>
                                        <div className="row mt-0 p-2">
                                            <div className="col-12">
                                                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Test Type</Tooltip>)}>
                                                    <select {...register("testTypeID", { required: "Test Type Required" })} className={`form-control  mt-3 ${errors.testTypeID ? 'is-invalid' : ''}`} style={{ height: 50, borderRadius: 15,fontSize:12 }}>
                                                        <option value="">Select Test Type</option>
                                                        {
                                                            testTypes.map((item, index) => (
                                                                <option key={index} value={item.testTypeID}>{item.testType}</option>
                                                            ))
                                                        }
                                                    </select>
                                                </OverlayTrigger>
                                                <div className="invalid-feedback"> {errors.testTypeID?.message}</div>
                                            </div>
                                        </div>
                                        <div className="row mt-0 p-2">
                                            <div className="col-12">
                                                {/* <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Question</Tooltip>)}>
                                                    <input type="text" title='' placeholder='Enter your Question' {...register("question", { required: "Question required" })} id="question" name="question" 
                                                        disabled={isDisabled} className={`form-control basic-form mt-3 ${errors.question ? 'is-invalid' : ''}`}
                                                    />
                                                </OverlayTrigger>
                                                <div className="invalid-feedback"> {errors.question?.message}</div> */}

<label style={{color:"#00a7ac"}}>Enter the Question</label>
<Controller
        control={control}
        name="question"
        rules={{
          required: { value: true, message: "Question Required" },
        }}
        render={({ field: { onChange, onBlur, value, ref } }) => (
          <div>
            <WYSIWYGEditor
              onChange={onChange}
              onBlur={onBlur}
              value={value}
              ref={ref}
              inputExtraProps={{
                required: true,
              }}
            />
            {errors.question && (
              <p style={{ marginTop: '0.25em', fontSize: '80%', color: '#dc3545' }}>
                {errors.question.message}
              </p>
            )}
          </div>
        )}
      />
                                            </div>
                                        </div>
                                        <div className="row mt-0 p-2">
                                            <div className="col-12">
                                                {/* <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Answer</Tooltip>)}>
                                                    <input type="text" title='' placeholder='Enter your Answer' {...register("answer", { required: "Answer required" })} id="answer" name="answer" 
                                                        disabled={isDisabled} className={`form-control basic-form mt-3 ${errors.answer ? 'is-invalid' : ''}`}
                                                    />
                                                </OverlayTrigger>
                                                <div className="invalid-feedback"> {errors.answer?.message}</div> */}
                                                <label style={{color:"#00a7ac"}}>Enter the Answer</label>
<Controller
        control={control}
        name="answer"
        rules={{
          required: { value: true, message: "Answer Required" },
        }}
        render={({ field: { onChange, onBlur, value, ref } }) => (
          <div>
            <WYSIWYGEditor
              onChange={onChange}
              onBlur={onBlur}
              value={value}
              ref={ref}
              inputExtraProps={{
                required: true,
              }}
            />
            {errors.answer && (
              <p style={{ marginTop: '0.25em', fontSize: '80%', color: '#dc3545' }}>
                {errors.answer.message}
              </p>
            )}
          </div>
        )}
      />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mb-4 mt-3 ">
                                        <div className="col-12"></div>
                                    </div>
                                    <Link to="/Employer/Questions"> 
                                     <button style={{ float: "right" }}  disabled={isSubmitting || isDisabled} className="btn btn-primary ">
                        Cancel
                      </button>
                      </Link>
                                    <button id="svbutton" style={{ float: "right" }} disabled={isSubmitting || isDisabled} className="btn btn-primary pf-save mb-3 mr-3">
                                        {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                                        Submit
                                    </button> &nbsp;&nbsp;&nbsp;
                                </form>
                                </div>
                            </div>
                        </div>
                }
            </section>
        </ConsultantLayout>
    );
}

export default AddQuestions;
